import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import GalleryPage from "./pages/GalleryPage";
import AboutPage from "./pages/AboutPage";
import MemberPricingPage from "./pages/MemberPricingPage";
import PackagesPricingPage from "./pages/PackagesPricingPage";
import NavBar from "./components/Navbar";

function App() {
  return (
    <div className="App">
      <Router>
        <NavBar />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/membership" element={<MemberPricingPage />} />
          <Route path="/packages" element={<PackagesPricingPage />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
